import React from 'react';
import { OpeningScreen } from '../screens/OpeningScreen';
import { ResponseScreen } from '../screens/ResponseScreen';
import { TransitionScreen } from '../screens/TransitionScreen';
import { FamilyScreen } from '../screens/FamilyScreen';
import { ProductScreen } from '../screens/ProductScreen';
import { PointScreen } from '../screens/PointScreen';
import { CloseScreen } from '../screens/CloseScreen';
import { POINT_STEP, PRODUCT_START } from '../../utils/snakSteps';
import type { FilteknProduct, SiblingRole } from '../../types/snak';
interface SnakStepViewProps {
  step: number;
  order: FilteknProduct[];
  role: SiblingRole | null;
  autoplayInterlude: boolean;
  onSelect: (role: SiblingRole) => void;
  onNext: () => void;
  onRestart: () => void;
  onDarken: (dark: boolean) => void;
}

/** Maps a step to its screen. Shared by the live Snak and the storyboard. */
export function SnakStepView({
  step,
  order,
  role,
  autoplayInterlude,
  onSelect,
  onNext,
  onRestart,
  onDarken
}: SnakStepViewProps) {
  if (step === 0) return <OpeningScreen selected={role} onSelect={onSelect} data-id="element-86" data-mp="2mekupywf6och" />;
  if (step === 1) return <ResponseScreen role={role ?? 'firstborn'} onNext={onNext} data-id="element-87" data-mp="2ifby8m9zwcd8" />;
  if (step === 2) {
    return <TransitionScreen autoplay={autoplayInterlude} onDarken={onDarken} onNext={onNext} data-id="element-88" data-mp="2w4vynlg3sxjd" />;
  }
  if (step === 3) return <FamilyScreen onNext={onNext} data-id="element-89" data-mp="2r96v770yqwhs" />;
  if (step < POINT_STEP) {
    const product = order[step - PRODUCT_START];
    if (!product) return null;
    return <ProductScreen product={product} position={step - PRODUCT_START + 1} total={order.length} onNext={onNext} data-id="element-90" data-mp="1zgpwr6akgj8s" />;
  }
  if (step === POINT_STEP) return <PointScreen onNext={onNext} data-id="element-91" data-mp="28g37s3ec9fvm" />;
  return <CloseScreen onRestart={onRestart} data-id="element-92" data-mp="28ifqiirx7u9q" />;
}